import React from 'react'
import {Modal, ModalBody} from 'reactstrap'
import ConfirmButton from '../button/confirm_button'

const CommonModal = React.memo((props) => {
  const {show = false, title = '', text = '', okBtn = '', cancelBtn = '', onModalClose} = props

  const onClose = res => {
    onModalClose?.(res || false)
  }

  return (
    <Modal isOpen={show} toggle={() => onClose(false)} className='modal-point-pay'>
      <ModalBody>
        <div className='modal-header-custom d-center position-relative'>
          <div className='fs-20 sm-fs-18 f-b'>{title}</div>
          <div className='modal-close-btn d-center position-absolute' onClick={() => onClose(false)}>
            <img src={'/assets/image/close.png'} alt='' className='modal-close'/>
          </div>
        </div>
        <div className='modal-po-lack text-center'>
          <div className='fs-18 sm-fs-14 f-m space-break'>{text}</div>
          <div className='d-center mt-60 sm-mt-20'>
            {okBtn != '' &&
            <ConfirmButton enabled={true} className={'bd-0 btn-point-pay fs-15 sm-fs-14 f-m d-center'} onClick={() => onClose(true)} text={okBtn} />
            }
            {cancelBtn != '' &&
            <ConfirmButton enabled={true} className={'btn-grey-border fs-15 sm-fs-14 f-m d-center ml-10'} onClick={() => {onClose(false)}} text={cancelBtn} />
            }
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
})

export default CommonModal
